import { InfiniteData, useQueryClient } from "@tanstack/react-query";
import { CacheKey } from "../../../constants/CacheKey";
import { Memory } from "../../../api/generated";
import { PaginationMemory } from "./useMemories";

/**
 * Memory一覧(`CacheKey.memories`)のreact-queryキャッシュを更新するためのヘルパー。
 */
export const useMemoriesCache = () => {
    const queryClient = useQueryClient();

    const replaceMemoryInCache = (memory: Memory) => {
        queryClient.setQueryData(
            CacheKey.memories,
            (cached: InfiniteData<PaginationMemory> | undefined) => {
                if (!cached) return cached;
                return {
                    ...cached,
                    pages: cached.pages.map((page) => ({
                        ...page,
                        memories: page.memories.map((m) =>
                            m.id === memory.id ? memory : m
                        ),
                    })),
                };
            }
        );
    };

    return { replaceMemoryInCache };
};
